import { MediaRequestInterface } from '../../../interfaces/request/media/media-request-interface';

export class MediaRequestModel implements MediaRequestInterface {
  creationDateEnd: string = '';
  creationDateStart: string = '';
  featureName: string = '';
  page: number = 1;
  pageSize: number = 5;
  state: string = '';

  constructor(init?: Partial<MediaRequestModel>) {
    Object.assign(this, init);
  }
}
